

import React, { useState ,useRef,useEffect} from "react";
import {
  Grid,
  Button,
  useMediaQuery,
  Box
} from "@mui/material";
import axios from 'axios'
import EducationView from './EducationView';
import ProfessionalView from './ProfessionalView';
import ViewProfile from './ViewProfile';
import FamilyView from './FamilyView';
import PartnerView from './PartnerView';
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import ViewDetaliesDashbord from "./ViewDetaliesDashbord";
import Header from "../Header";
import { useLocation } from "react-router-dom";
import { matrimoneyEndPoints } from '../../../services/apis';
import Footer from '../Footer'
import CustomerFollows from "./customerFollowsView";
const Profileroutes = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuType, setMenuType] = useState("");
  const [selectedTab, setSelectedTab] = useState("Profile Details");
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();
  const location = useLocation();
  const profileId = location.state?.profileId;
  const [profileData,setProfileData] = useState(null)
  let apiCall = useRef(false)
  let action = sessionStorage.getItem("action")
  const userType = sessionStorage.getItem("userType")
  const getCustomerData = async () => {
    try {
      let userType = sessionStorage.getItem("userType")
	let token
	if(userType){
		token = sessionStorage.getItem("token");
	}else{
		 token = localStorage.getItem("token");
	}
      const response = await axios.post(
        matrimoneyEndPoints.VIEW_CUSTOMER_DETAILS,
        { profileId: profileId},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.status) {
        setProfileData(response.data);
      }
    } catch (error) {
      console.error("GET_HEALTH_CONDITION_LIST API ERROR:", error);
    } 
  };

  useEffect(() => {
    if (!apiCall.current) {
      apiCall.current = true
      getCustomerData();
    }
  }, []);
  const handleClick = (event, type) => {
    setAnchorEl(event.currentTarget);
    setMenuType(type);
    setSelectedTab(type); 
  };

  const handleButtonClick = (label) => {
    setSelectedTab(label);
  };

  return (
    <Box>
      {action!= "viewProfile" && <Header/>}
      <Box>
      <ViewDetaliesDashbord profileData = {profileData} profileId={profileId}/>
      </Box>
    <Grid
      container
      sx={{
        marginTop: { xs: "10px",sm: "1px" },
        width: "100%",
      }}
    >
      {(userType == "STAFF" ? [
        { label: "Profile Details" },
        { label: "Education Details" },
        { label: "Family Details" },
        { label: "Partner Details" },
        { label: "Customer Info" },
      ] :  [
        { label: "Profile Details" },
        { label: "Education Details" },
        // { label: "Professional Details" },
        { label: "Family Details" },
        { label: "Partner Details" },
      ]).map((item, index, arr) => (
        <Grid
          item
          xs={12}
          sm={userType == "STAFF" ? 2.4 : 3}
          key={index}
          sx={{
            borderRight:
              !isMobile && index !== arr.length - 1
                ? "2px solid white"
                : "none",
            borderBottom:
              isMobile && index !== arr.length - 1
                ? "2px solid white"
                : "none",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: 0,
            cursor:"pointer"
          }}
        >
          <Button
            startIcon={item.icon}
            endIcon={item.hasDropdown ? <ArrowDropDownIcon /> : null}
            onClick={() =>
              item.hasDropdown
                ? handleClick(item.label)
                : handleButtonClick(item.label)
            }
            sx={{
              backgroundColor:
                selectedTab === item.label ? "#c1721f" : "#fffcf4", // "rgb(255, 234, 241)",
              color: selectedTab === item.label ? "white" : "#c1721f",
              textTransform: "none",
              width: "100%",
              display: "flex",
              justifyContent:{xs:"left",sm: "center"},
              alignItems: {xs:"left",sm: "center"},
              borderRadius: 0,
              fontSize:{xs:"24px",sm:"16px"},
              fontFamily: '"SF Pro Display", sans-serif',
              fontWeight: 500,
              borderRight:"3px solid #f7e9d3",
              height:{xs:"50px",sm:"auto"},
              // padding:{xs:"0px",sm:"6px 25px"},
              lineHeight:"30px",
              "&:hover": {
                backgroundColor:
                  selectedTab === item.label ? "#c1721f" : "#c1721f",
                  color:
                   selectedTab === item.label ? "white" : "white",

              },
            }}
          >
            {item.label}
          </Button>
        </Grid>
      ))}
       <Box sx={{ padding: "30px" }}>
        {
              selectedTab === "Profile Details" &&(
                <ViewProfile profileData={profileData && profileData?.status ? profileData?.data : null} profileId={profileId}/>
              )
        }
        {
            selectedTab === "Education Details" &&(
              <EducationView educationalData=  {profileData && profileData?.status ? profileData?.data : null} profileId={profileId}/>
            )
        }
          {
            selectedTab === "Professional Details" &&(
              <ProfessionalView professionalData=  {profileData && profileData?.status ? profileData?.data["Profession Details"] : null} profileId={profileId}/>
            )
        }
          {
            selectedTab === "Family Details" &&(
              <FamilyView profileData=  {profileData && profileData?.status ? profileData?.data : null} profileId={profileId}/>
            )
        }
          {
            selectedTab === "Partner Details" &&(
              <PartnerView partnerData=  {profileData && profileData?.status ? profileData?.data["Partner Details"] : null} profileId={profileId}/>
            )
        }
        {
            selectedTab === "Customer Info" &&(
              <CustomerFollows profileId={profileId}/>
            )
        }
        
      </Box>
    </Grid>
    <Footer/>
    </Box>
  );
};

export default Profileroutes;
